// Text constants used in the Login screen UI

// Main heading for the login page
export const LoginHeading = 'Hello'

// Subtext or subtitle prompting user to sign in
export const LoginText = 'Sign to your account'

// Label for "Forgot Password" link/button
export const ForgotText = 'Forgot Password'

// Label for the "Reset Password" screen
export const ResetText = 'Reset Password'

// Button text for Google Sign-In option
export const SignInButtonGoogle = 'Sign In With Google'

// Prompt text for users who do not have an account
export const NoAccountText = 'Don’t have an account?'

// Call to action directing users to contact admin
export const Contact = 'Contact Your Admin'

// Full message guiding users to contact the admin if login fails
export const NOACCOUNT_CONTACT = 'Please connect with your admin in case you are unable to login.'
